/**
 * Created by chantell.nichols on 9/8/2015.
 */
/**
 * Template Settings
 *
 * @module Availability
 */
ISMDSPlugin.define('src/js/templates/templateSettings',{
  Priority: [0, .25, .50, .75, 1],
  Segment: {
    '75%-100%': {
      /**
       * the default interior color for segments with HIGH availability
       * @type String|Hex
       * @final
       */
      interiorColor: '#004878',
      /**
       * the low end of the range of seat availability needed to be considered NONE
       * @type Number
       * @final
       */
      lowRange: .75,
      /**
       * the high end of the range of seat availability needed to be considered NONE
       * @type Number
       * @final
       */
      highRange: 1
    },
    '25%-75%': {
      /**
       * the default interior color for segments with MEDIUM availability
       * @type String|Hex
       * @final
       */
      interiorColor: '#1099de',
      /**
       * the low end of the range of seat availability needed to be considered NONE
       * @type Number
       * @final
       */
      lowRange: .25,
      /**
       * the high end of the range of seat availability needed to be considered NONE
       * @type Number
       * @final
       */
      highRange: .75
    },
    '0%-25%': {
      /**
       * the default interior color for segments with LOW availability
       * @type String|Hex
       * @final
       */
      interiorColor: '#91c9ea',
      /**
       * the low end of the range of seat availability needed to be considered NONE
       * @type Number
       * @final
       */
      lowRange: 0,
      /**
       * the high end of the range of seat availability needed to be considered NONE
       * @type Number
       * @final
       */
      highRange: .25
    },
    '0%-0%': {
      /**
       * the default interior color for segments with NONE availability
       * @type String|Hex
       * @final
       */
      interiorColor: '#999999',
      /**
       * the low end of the range of seat availability needed to be considered NONE
       * @type Number
       * @final
       */
      lowRange: 0,
      /**
       * the high end of the range of seat availability needed to be considered NONE
       * @type Number
       * @final
       */
      highRange: 0
    }
  },
  Place: {
    'true': {
      /**
       * the default interior color for places with OPEN status
       * @type String|Hex
       * @final
       */
      interiorColor: '#004878'
    },
    'false': {
      /**
       * the default interior color for places with SOLD status
       * @type String|Hex
       * @final
       */
      interiorColor: '#999999'
    }
  }
});

